/* eslint-disable max-lines */
import React from 'react';
import {Card} from 'semantic-ui-react';

const Header = () => {
  return (
    <Card fluid>
      <div className="title-bar center-vertical">
        <div className="title center-vertical">
          <h2>
            Seguimiento de cliente
          </h2>
        </div>
      </div>
    </Card>
  );
};

export default Header;
